export class BusinessContextPayload {
    entityId: number;
    contextName: string;
}
